import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnDestroy, OnInit } from '@angular/core';
import { IsActiveMatchOptions } from '@angular/router';
import { HemroNavigationService } from '@hemro/components/navigation/navigation.service';
import { HemroNavigationItem } from '@hemro/components/navigation/navigation.types';
import { HemroVerticalNavigationComponent } from '@hemro/components/navigation/vertical/vertical.component';
import { HemroUtilsService } from '@hemro/services/utils/utils.service';
import { Subject, takeUntil } from 'rxjs';


@Component({
    selector       : 'hemro-vertical-navigation-basic-item',
    templateUrl    : './basic.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HemroVerticalNavigationBasicItemComponent implements OnInit, OnDestroy
{
    @Input() item: HemroNavigationItem;
    @Input() name: string;

    isActiveMatchOptions: IsActiveMatchOptions;
    private _hemroVerticalNavigationComponent: HemroVerticalNavigationComponent;
    private _unsubscribeAll: Subject<any> = new Subject<any>();

    /**
     * Constructor
     */
    constructor(
        private _changeDetectorRef: ChangeDetectorRef,
        private _hemroNavigationService: HemroNavigationService,
        private _hemroUtilsService: HemroUtilsService
    )
    {
        // Set the equivalent of {exact: false} as default for active match options.
        // We are not assigning the item.isActiveMatchOptions directly to the
        // [routerLinkActiveOptions] because if it's "undefined" initially, the router
        // will throw an error and stop working.
        this.isActiveMatchOptions = this._hemroUtilsService.subsetMatchOptions;
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Lifecycle hooks
    // -----------------------------------------------------------------------------------------------------

    /**
     * On init
     */
    ngOnInit(): void
    {
        // Set the "isActiveMatchOptions" either from item's
        // "isActiveMatchOptions" or the equivalent form of
        // item's "exactMatch" option
        this.isActiveMatchOptions =
            this.item.isActiveMatchOptions ?? this.item.exactMatch
                ? this._hemroUtilsService.exactMatchOptions
                : this._hemroUtilsService.subsetMatchOptions;

        // Get the parent navigation component
        this._hemroVerticalNavigationComponent = this._hemroNavigationService.getComponent(this.name);
        this._hemroNavigationService.storeNavigation(this.item.id, [this.item]);

        // Mark for check
        this._changeDetectorRef.markForCheck();

        // Subscribe to onRefreshed on the navigation component
        this._hemroVerticalNavigationComponent.onRefreshed.pipe(
            takeUntil(this._unsubscribeAll)
        ).subscribe(() => {

            // Mark for check
            this._changeDetectorRef.markForCheck();
        });
    }

    /**
     * On destroy
     */
    ngOnDestroy(): void
    {
        // Unsubscribe from all subscriptions
        this._unsubscribeAll.next(null);
        this._unsubscribeAll.complete();
    }
}
